import { Application } from "@hotwired/stimulus";
import hljs from 'highlight.js';

// @ts-ignore
import LineifyPlugin from './Js/highlightjs-lineify.js';

function lineifyCallback(element: HTMLDivElement, lineElements: any) {
    if (element.tagName === 'SPAN') {
        return
    }
    for (let i = 0; i < lineElements.length; i++) {
        let lineElement = lineElements[i];
        // @ts-ignore
        lineElement.insertBefore(this.createLineNumSpan(i + 1), lineElement.firstChild);
    }
}

hljs.addPlugin(new LineifyPlugin(lineifyCallback));

// We decided to use https://stimulus.hotwired.dev/ to write js code
// as it provides a great way to structure and develop js components.
import PageMenu from "./Fusion/Presentation/Components/PageMenu/PageMenu";
import ServiceMenu from "./Fusion/Presentation/Components/ServiceMenu/ServiceMenu";
import LanguageMenu from "./Fusion/Presentation/Components/LanguageMenu/LanguageMenu";
import Slider from "./Fusion/Presentation/Components/Slider/Slider";

declare global {
    interface Window {
        Stimulus: any;
        ErrorTrackingSystem: any;
    }
}

const Stimulus = Application.start();
// we decided to add controllers manually as we want to use our own folder structure
// for ts/js
Stimulus.register("PageMenu", PageMenu);
Stimulus.register("ServiceMenu", ServiceMenu);
Stimulus.register("Slider", Slider);
Stimulus.register("LanguageMenu", LanguageMenu);

// enable if needed
// Stimulus.debug = true;
window.Stimulus = Stimulus;

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.sourcecode').forEach((el: any) => {
        // then highlight each
        hljs.highlightElement(el);

        const filename = el.dataset.filename
        if (!filename) return

        el.classList.add('code-block--with-header')
        const node = document.createElement("div");
        node.classList.add('code-block__header')
        node.appendChild(document.createTextNode(filename));
        el.prepend(node);
    });
});
